import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=f6300944&scoped=true&"
import script from "./LeadsTable.vue?vue&type=script&lang=js&"
export * from "./LeadsTable.vue?vue&type=script&lang=js&"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=f6300944&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6300944",
  null
  
)

export default component.exports